import React from 'react';
import { cn } from '../../lib/utils';

const badgeVariants = {
  base: 'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors',
  variants: {
    default: 'bg-primary text-white',
    secondary: 'bg-secondary text-secondary-foreground',
    success: 'bg-success-100 text-success-800',
    warning: 'bg-warning-100 text-warning-800',
    danger: 'bg-danger-100 text-danger-800',
    outline: 'border border-border bg-transparent text-foreground',
    muted: 'bg-hover text-muted',
  },
};

const Badge = React.forwardRef(({
  className,
  variant = 'default',
  children,
  ...props
}, ref) => {
  return (
    <span
      ref={ref}
      className={cn(
        badgeVariants.base,
        badgeVariants.variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
});

Badge.displayName = 'Badge';

export { Badge, badgeVariants };
